import BrandTitle from '@/components/brandTitle'

export const ASSET_DIR = '/assets/images/agri-input'

export const STRINGS = {
  PAGE_TITLE: 'DeHaat | Agri Input',
  PAGE_DESCRIPTION:
    'DeHaat connects farmers to suppliers and buyers on a single platform. Online marketplace providing all the agricultural products and services to farmers.',
  AGRI_INPUT: 'Agri Input',
  SEED_FERTILIZERS_PESTICIDES: 'Seed, Fertilizers & Pesticides',
  DESCRIPTION:
    "Input material at the beginning of farming cycle is the most important aspect that determines the quality and volume of the output - hence the income and livelihood of the farmer. Serious gaps in the agri-input value chain exist due to demand and supply mismatch, substandard locally manufactured products, duplication, adulteration, and black-marketing of key products.\n\nFarmers are often misguided about the variety, solution, and dosage of Seed, Fertilizer and Pesticide they should be using. Our objective is to provide agri input of right Kind of right Quality at right Price and at right Time.\n\nOur robust technology solutions for supply chain management enables us to provide direct cost saving to the farmer up to 15%, delivery of input at farmers' doorstep and post-sales support with advisory on usage and monitoring Health & Growth of the crop as the cropping season wears on.",
  BLESSING: 'How A Handheld Device Proved A Blessing ?',
  GAUTAM_SINGH: 'Gautam Singh (DeHaat Micro entrepreneur)',
  ABOUT_GAUTAM_SINGH:
    "Gautam Singh (37) had been working as a driver in Delhi since past 12 years at monthly salary of INR 10,000 only. However his wife and 3 kids used to stay at his native village in Vaishali district. In his absence, wife could barely manage the family farming at 2 acre of land and neither education and healthcare needs of kids were being taken properly. He got to know about DeHaat and it's micro-entrepreneurship plan when he had been to his village once. In July 2016 he started DeHaat in his village Jaitipur, Vaishali. Currently he is serving 726 local farmers through DeHaat Jaitipur and undergoes an annual transaction of INR 62 Lakh and earning INR 12000-INR 17000 on monthly basis. All his three kids go to a private school and neither his wife has to take care of farm alone.",
  DEHAAT_BUSINESS_APP: 'DeHaat-Business APP',
  DEHAAT_FARMER_APP: 'DeHaat-Farmer APP',
  BAYER: 'BAYER',
  AGRINOS: 'AGRINOS',
  DU_PONT: 'DU PONT',
  IFFCO: 'IFFCO',
  MONSANTO: 'MONSANTO',
  PIONEER: 'PIONEER',
  YARA: 'YARA',
  UPL: 'UPL',
}

export const appList = [
  {
    icon: '/assets/images/farmer',
    alt: STRINGS.DEHAAT_FARMER_APP,
    appName: STRINGS.DEHAAT_FARMER_APP,
    appLink:
      'https://play.google.com/store/apps/details?id=app.intspvt.com.farmer',
  },
  {
    icon: '/assets/images/business-app',
    alt: STRINGS.DEHAAT_BUSINESS_APP,
    appName: STRINGS.DEHAAT_BUSINESS_APP,
    appLink:
      'https://play.google.com/store/apps/details?id=com.intspvt.app.dehaat2',
  },
]

export const imageList = [
  {
    image: `${ASSET_DIR}/agri-input-1`,
    alt: 'Farmer spraying pesticide',
  },
  {
    image: `${ASSET_DIR}/agri-input-2`,
    alt: 'Transport vehicle with DeHaat Agri Input advertisement',
  },
  {
    image: `${ASSET_DIR}/agri-input-3`,
    alt: 'DeHaat center',
  },
  {
    image: `${ASSET_DIR}/agri-input-4`,
    alt: 'Transport vehicle with DeHaat advertisement',
  },
  {
    image: `${ASSET_DIR}/agri-input-5`,
    alt: "Farmers with DeHaat's agri input products",
  },
  {
    image: `${ASSET_DIR}/agri-input-6`,
    alt: 'Agri Input',
  },
  {
    image: `${ASSET_DIR}/agri-input-7`,
    alt: 'Farmer taking DeHaat agri input products on tractor',
  },
]

export const brandList = [
  {
    image: `${ASSET_DIR}/bayer`,
    alt: STRINGS.BAYER,
    title: <BrandTitle title={STRINGS.BAYER} />,
  },
  {
    image: `${ASSET_DIR}/agrinos`,
    alt: STRINGS.AGRINOS,
    title: <BrandTitle title={STRINGS.AGRINOS} />,
  },
  {
    image: `${ASSET_DIR}/du-pont`,
    alt: STRINGS.DU_PONT,
    title: <BrandTitle title={STRINGS.DU_PONT} />,
  },
  {
    image: `${ASSET_DIR}/iffco`,
    alt: STRINGS.IFFCO,
    title: <BrandTitle title={STRINGS.IFFCO} />,
  },
  {
    image: `${ASSET_DIR}/monsanto`,
    alt: STRINGS.MONSANTO,
    title: <BrandTitle title={STRINGS.MONSANTO} />,
  },
  {
    image: `${ASSET_DIR}/pioneer`,
    alt: STRINGS.PIONEER,
    title: <BrandTitle title={STRINGS.PIONEER} />,
  },
  {
    image: `${ASSET_DIR}/yara`,
    alt: STRINGS.YARA,
    title: <BrandTitle title={STRINGS.YARA} />,
  },
  {
    image: `${ASSET_DIR}/upl`,
    alt: STRINGS.UPL,
    title: <BrandTitle title={STRINGS.UPL} />,
  },
]
